import { css } from "@assets/style/util/cssUtils"
import mergeClasses from "@assets/style/util/mergeClasses"
import { InputBase, InputBaseProps } from "@material-ui/core"
import Skeleton from "@material-ui/lab/Skeleton"
import classnames from "classnames"
import React from "react"
import classes from "./DiscoInput.module.css"

export type DiscoInputProps = {
  minHeight?: string
  padding?: string
  size?: DiscoInputSize
  disableFocus?: boolean
  disableHover?: boolean
  ref?: React.Ref<HTMLInputElement | HTMLTextAreaElement>
} & InputBaseProps

type DiscoInputSize = "large" | "small"

const DiscoInput = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  DiscoInputProps
>(
  (
    {
      minHeight,
      padding,
      classes: customClasses,
      size = "small",
      value,
      disableFocus = false,
      disableHover = false,
      ...props
    },
    ref
  ) => {
    const rootClasses = classnames(classes.root, {
      [classes.large]: size === "large",
      [classes.multiline]: props.multiline,
      [classes.focusable]: !disableFocus,
      [classes.hoverable]: !disableHover,
    })

    const merged = mergeClasses(customClasses, {
      root: rootClasses,
      input: classes.input,
      adornedStart: classes.adornedStart,
      adornedEnd: classes.adornedEnd,
    })

    return (
      <InputBase
        ref={ref}
        classes={merged}
        style={css({
          "--disco-input-min-height": minHeight,
          "--disco-input-padding": padding,
        })}
        onKeyDown={(e) => e.stopPropagation()}
        value={value === null ? "" : value}
        {...props}
      />
    )
  }
)

export default DiscoInput

type DiscoInputSkeletonProps = {
  height?: number
  flexGrow?: number
  style?: React.CSSProperties
}

export const DiscoInputSkeleton: React.FC<DiscoInputSkeletonProps> = ({
  height,
  flexGrow,
  style,
}) => {
  return (
    <Skeleton
      variant={"rect"}
      style={{
        borderRadius: "var(--groovy-border-radius-12)",
        flexGrow,
        ...style,
      }}
      height={height || 40}
    />
  )
}
